import { i18nextAction } from './types';
import { SET_LANGUAGE } from './constants';

export const setLanguage = (payload: string): i18nextAction => {
  return {
    type: SET_LANGUAGE,
    payload,
  };
};
